<div class="contracts-panel">
  <div class="contracts-toolbar" fxLayout="row" fxLayoutAlign="space-between center">
    <span class="contracts-count" *ngIf="customer?.id && !loading">
      {{ contracts.length }} contrato(s)
    </span>
    <span fxFlex *ngIf="!customer?.id || loading"></span>
    <button
      type="button"
      mat-stroked-button
      class="manage-button"
      [disabled]="!customer?.id"
      (click)="openManager()">
      GERENCIAR CONTRATOS
    </button>
  </div>

  <p class="contracts-empty" *ngIf="!customer?.id">
    Salve o cliente para listar os contratos.
  </p>
  <p class="contracts-empty" *ngIf="customer?.id && loading">Carregando contratos...</p>
  <p class="contracts-empty" *ngIf="customer?.id && !loading && contracts.length === 0">
    Nenhum contrato encontrado para este cliente.
  </p>

  <table
    mat-table
    [dataSource]="contracts"
    *ngIf="customer?.id && !loading && contracts.length"
    class="contracts-table">
    <ng-container matColumnDef="code">
      <th mat-header-cell *matHeaderCellDef>CÓDIGO</th>
      <td mat-cell *matCellDef="let contract">{{ code(contract) }}</td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>STATUS</th>
      <td mat-cell *matCellDef="let contract">{{ statusLabel(contract) }}</td>
    </ng-container>
    <ng-container matColumnDef="updatedAt">
      <th mat-header-cell *matHeaderCellDef>ATUALIZADO EM</th>
      <td mat-cell *matCellDef="let contract">{{ updatedAt(contract) }}</td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="openManager()"></tr>
  </table>
</div>
